import { useQuery } from 'react-query';
import { fetchUserAccomplishments } from '../fetchers/accomplishments';

export const useUserAccomplishments = (userUid) => {
  const { data, isLoading, error } = useQuery(
    ['user-accomplishments', userUid],
    () => fetchUserAccomplishments(userUid),
    { enabled: !!userUid },
  );

  return {
    accomplishments: data || [],
    isLoading,
    error,
  };
};
